import React from 'react';
import { PRICE_KUNDLI_QUESTION, PRICE_KUNDLI_QUESTION_OLD } from '../constants/pricingCopy';
import StruckPrice from './StruckPrice';

/**
 * Shown on dashboard when the profile has a saved question (10+ chars) and
 * there is no paid kundli_questions row for that exact question yet.
 */
export default function ShastraProfileQuestionModal({
  open,
  question,
  onClose,
  onUnlock,
  /** Backend-verified: has this account NOT yet used its one free Shastra AI question? UI hint only. */
  freeQuestionAvailable = false,
}) {
  if (!open) return null;

  return (
    <div
      className="ks-modal-scrim"
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 20040,
        background: 'rgba(0,0,0,.52)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        backdropFilter: 'blur(2px)',
      }}
      onClick={onClose}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="shastra-welcome-title"
        style={{
          width: 'min(440px, 100%)',
          maxHeight: 'min(90vh, 640px)',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '16px',
          background: 'linear-gradient(180deg,#fff7ed,#fffbeb)',
          border: '1px solid #fde68a',
          boxShadow: '0 16px 48px rgba(0,0,0,.2)',
          fontFamily: 'system-ui,-apple-system,sans-serif',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ padding: '1.25rem 1.25rem 0.5rem' }}>
          <h2
            id="shastra-welcome-title"
            style={{ fontSize: '1.15rem', fontWeight: 800, color: '#78350f', margin: 0, lineHeight: 1.3 }}
          >
            Aapka sawaal
          </h2>
          <p style={{ fontSize: '0.8rem', color: '#92400e', margin: '0.4rem 0 0', lineHeight: 1.45 }}>
            {freeQuestionAvailable ? (
              <>Is profile par yeh sawaal save hai. 🎁 Answer dekhne ke liye FREE mein unlock karein — koi payment nahi.</>
            ) : (
              <>
                Is profile par yeh sawaal save hai. Answer dekhne ke liye{' '}
                <StruckPrice oldPrice={PRICE_KUNDLI_QUESTION_OLD} newPrice={PRICE_KUNDLI_QUESTION} /> se unlock karein.
              </>
            )}
          </p>
        </div>
        <div
          style={{
            margin: '0.75rem 1.25rem 0',
            padding: '0.85rem 1rem',
            borderRadius: '12px',
            background: 'rgba(255,255,255,.85)',
            border: '1px solid #fde68a',
            fontSize: '0.9rem',
            lineHeight: 1.5,
            color: '#44403c',
            maxHeight: 'min(40vh, 220px)',
            overflowY: 'auto',
          }}
        >
          {question}
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            padding: '1.1rem 1.25rem 1.25rem',
            marginTop: 'auto',
          }}
        >
          <button
            type="button"
            onClick={onUnlock}
            style={{
              width: '100%',
              minHeight: '48px',
              border: 'none',
              borderRadius: '12px',
              fontWeight: 800,
              fontSize: '0.95rem',
              color: '#fffbeb',
              cursor: 'pointer',
              background: 'linear-gradient(90deg,#78350f,#b45309)',
              boxShadow: '0 6px 20px rgba(120,53,15,.3)',
            }}
          >
            {freeQuestionAvailable ? (
              <>🎁 Get Your First Answer FREE</>
            ) : (
              <>
                Unlock your answer — <StruckPrice oldPrice={PRICE_KUNDLI_QUESTION_OLD} newPrice={PRICE_KUNDLI_QUESTION} className="text-[#fffbeb]" /> →
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onClose}
            style={{
              width: '100%',
              padding: '0.55rem',
              border: '1px solid #d6d3d1',
              borderRadius: '10px',
              background: '#fafaf9',
              color: '#57534e',
              fontSize: '0.85rem',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Baad mein
          </button>
        </div>
      </div>
    </div>
  );
}
